export default {
  "member": "Membre",
  "staff": "Personnel",
  "external": "Externe",
  "unableToLoadBoardMembers": "Incapable de charger des membres du conseil",
  "pleaseTryAgainShortly": "Veuillez réessayer prochainement.",
  "pleaseUploadAnImageFile": "Veuillez télécharger un fichier image.",
  "imageMustBe5MBOrSmaller": "L'image doit être de 5Mo ou plus petite.",
  "nameIsRequired": "Le nom est requis.",
  "pleaseSelectAMemberFromSearch": "Veuillez sélectionner un membre à partir de la recherche.",
  "pleaseSelectAStaffRecordFromSearch": "Veuillez sélectionner un dossier personnel à partir de la recherche.",
  "enterAValidEmailAddress": "Entrez une adresse email valide.",
  "boardMemberAdded": "Membre du Conseil",
  "theRosterHasBeenUpdatedSuccessfully": "Le fichier a été mis à jour avec succès.",
  "unableToAddBoardMember": "Incapable d'ajouter un membre du conseil",
  "pleaseReviewTheDetailsAndTryAgain": "Veuillez réexaminer les détails et réessayer.",
  "unableToUpdateStatus": "Incapable de mettre à jour le statut",
  "pleaseTryAgain": "Veuillez réessayer.",
  "roleTitleIsTooLong": "Le titre de rôle est trop long",
  "roleTitleMustBe80CharactersOrFewer": "Le titre de rôle doit être de 80 caractères ou moins.",
  "roleUpdated": "Rôle mis à jour",
  "boardMemberRoleHasBeenUpdated": "Le rôle des membres du Conseil a été mis à jour.",
  "unableToUpdateRole": "Incapable de mettre à jour le rôle",
  "boardMemberRemoved": "Membre du Conseil enlevé",
  "theBoardRosterHasBeenUpdated": "La liste des membres a été mise à jour.",
  "unableToRemoveBoardMember": "Incapable d'enlever le membre du conseil",
  "roster": "Planning du personnel",
  "boardMembers": "Membres du Conseil",
  "manageTheDirectorsOfficersAndExternalAdvisorsWhoShapeGovernanceDecisions": "Gérer les directeurs, les dirigeants et les conseillers externes qui façonnent les décisions de gouvernance.",
  "addBoardMember": "Ajouter un membre du conseil",
  "buildYourGovernanceRoster": "Construisez votre fichier de gouvernance",
  "addBoardDirectorsStaffLiaisonsOrExternalAdvisorsToPrepareForSecureVoting": "Ajouter les directeurs du conseil, les liaisons avec le personnel ou les conseillers externes pour se préparer au vote sécurisé.",
  "trackMemberTypeRoleTitlesAndAccessStatusInOnePremiumRoster": "Suivre le type de membre, les titres de rôle et l'état d'accès dans un fichier de primes.",
  "activeRoster": "Fichier actif",
  "keepTheBoardRosterCurrentForSecureGovernanceAndFutureVotingWorkflows": "Tenir la liste des membres à jour pour assurer la gouvernance et les futures activités de vote.",
  "role": "Rôle",
  "type": "Type",
  "contact": "Contact",
  "status": "Statut",
  "actions": "Actions",
  "boardMember": "Membre du Conseil",
  "active": "Actif",
  "inactive": "Inactif",
  "boardMemberActions": "Mesures prises par les membres du Conseil",
  "editRole": "Éditer le rôle",
  "delete": "Supprimer",
  "memberType": "Type de membre",
  "selectType": "Sélectionnez le type",
  "selectFromTheMemberDirectory": "Sélectionnez dans le répertoire des membres.",
  "selectFromTheStaffDirectory": "Sélectionnez dans le répertoire personnel.",
  "enterManuallyAndOptionallyUploadAnAvatar": "Entrez manuellement et en option télécharger un avatar.",
  "roleTitle": "Titre du rôle",
  "chairTreasurer": "Président, Trésorier",
  "name": "Nom",
  "searchStaffNameOrEmail": "Nom du personnel de recherche ou courriel",
  "searchMemberNameOr": "Nom du membre de recherche ou #",
  "clearSelection": "Sélection claire",
  "type2CharactersToSearch": "Type 2+ caractères à la recherche",
  "loading": "Chargement…",
  "noResults": "Aucun résultat",
  "janeCarter": "Jane Carter",
  "email": "E-mail",
  "optionalDirectorySelectionCanPrefillThis": "Optionnel. La sélection du répertoire peut préremplir ceci.",
  "avatarImage": "Image Avatar",
  "avatarPreview": "Aperçu Avatar",
  "uploadJPGPNGGIFOrWebPUpTo5MB": "Téléchargez JPG, PNG, GIF ou WebP jusqu'à 5Mo.",
  "clearUploadedOverride": "Retransmissions nettes",
  "boardMemberRecordsAreScopedToThisClubTenant": "Les dossiers des membres du conseil d'administration sont étendus à ce locataire du club.",
  "cancel": "Annuler",
  "saving": "Enregistrement…",
  "addMember": "Ajouter un membre",
  "memberAvatar": "Membre avatar",
  "avatarUnavailable": "Avatar non disponible",
  "close": "Fermer",
  "upTo80CharactersLeaveEmptyToClear": "Jusqu'à 80 caractères. Laisser vide à clair.",
  "save": "Enregistrer",
  "removeBoardMember": "Enlever le membre du conseil?",
  "thisCanBeUndoneByAnAdmin": "Cela peut être fait par un administrateur.",
  "removing": "Enlever...",
  "remove": "Retirer",
  "revenue": "Chiffre d’affaires",
  "expenses": "Dépenses",
  "yTDRevenue": "Revenu yTD",
  "memberEngagement": "Engagement des membres",
  "activeMembersThisMonth": "Membres actifs ce mois-ci",
  "openSafetyIncidents": "Incidents de sécurité ouvert",
  "requiresBoardReview": "Nécessité de l ' examen du conseil",
  "financialOverview": "Situation financière",
  "revenueBreakdown": "Répartition des recettes",
  "noRevenueDataYet": "Pas de données sur les recettes",
  "monthlyRevenueTrend": "Tendance mensuelle du revenu",
  "noMonthlyRevenueDataYet": "Pas de données mensuelles sur les recettes",
  "topExpenseCategories": "Top Catégories d'Encens",
  "noExpenseDataYet": "Pas de données de dépense encore",
  "nA": "N/A",
  "noDecisionsRequiringAction": "Aucune décision exigeant une action",
  "whenNewMotionsAreSubmittedTheyWillAppearHere": "Lorsque de nouvelles motions seront présentées, elles apparaîtront ici.",
  "noPriorComparisonAvailable": "Aucune comparaison préalable disponible",
  "decisionSpotlight": "Décision Spotlight",
  "budgetApproval": "Approbation du budget",
  "totalBudget": "Total",
  "monthlyAverage": "Moyenne mensuelle",
  "varianceVsPrior": "Écart par rapport à la période précédente",
  "error": "Erreur",
  "validationError": "Erreur de validation",
  "pleaseSelectAFileAndEnterACategory": "Veuillez sélectionner un fichier et entrez une catégorie.",
  "success": "Succès",
  "documentUploadedSuccessfully": "Document téléchargé avec succès.",
  "areYouSureYouWantToDeleteThisDocument": "Êtes-vous sûr de vouloir supprimer ce document?",
  "documentDeletedSuccessfully": "Document supprimé avec succès.",
  "documentsAndPolicies": "Documents et politiques",
  "searchDocuments": "Les documents de recherche...",
  "documentCategory": "Catégorie",
  "chooseFile": "Choisir un fichier",
  "uploading": "Chargement...",
  "uploadDocument": "Télécharger le document",
  "category": "Catégorie",
  "version": "Version",
  "lastUpdated": "Dernière mise à jour",
  "loadingDocuments": "Chargement des documents...",
  "download": "Télécharger",
  "noDocumentsFound": "Pas de documents trouvés.",
  "failedToLoadDocuments": "N'a pas chargé de documents.",
  "failedToUploadDocument": "N'a pas téléchargé le document.",
  "failedToDeleteDocument": "N'a pas supprimé le document.",
  "meetings": "Réunions",
  "createMeeting": "Créer une réunion",
  "upcomingMeetings": "Réunions à venir",
  "pleaseSelectAClubToViewMeetings": "Veuillez sélectionner un club pour voir les réunions.",
  "attendees": "participantes",
  "viewDetails": "Voir les détails",
  "noUpcomingMeetingsScheduled": "Aucune réunion à venir n ' est prévue.",
  "pastMeetings": "Réunions antérieures",
  "pleaseSelectAClubToViewPastMeetings": "Veuillez sélectionner un club pour voir les réunions passées.",
  "viewMinutes": "Voir Minutes",
  "noPastMeetingsFound": "Aucune réunion précédente n'a été trouvée.",
  "notYetOpenForVoting": "Pas encore ouvert au vote",
  "pendingForOpenVoting": "En attendant le vote ouvert",
  "votingInProgress": "Vote en cours",
  "votingCompleted": "Terminé le vote",
  "submissionWithdrawn": "Demande retirée",
  "boardDecision": "Décision du Conseil",
  "created": "Créé",
  "createdBy": "Créé par",
  "boardSecretariat": "Secrétariat du Conseil",
  "yes": "Oui",
  "no": "Non",
  "abstain": "S’abstenir",
  "youVoted": "Tu as voté.",
  "outcome": "Résultat :",
  "review": "Examen",
  "openVoting": "Vote ouvert",
  "pendingForOpen": "En attente pour Open",
  "thisMotionIsQueuedForVotingOnceLeadershipOpensTheBallotWindow": "Cette motion est reportée au vote une fois que le leadership ouvre la fenêtre du scrutin.",
  "closes": "Fermes",
  "boardPackSummary": "Tableau récapitulatif",
  "allocationByDepartment": "Répartition par département",
  "noAllocationDataAvailable": "Aucune donnée d ' allocation n ' est disponible.",
  "whatChangedVsLastYear": "Qu'est-ce qui a changé l'an dernier ?",
  "noPriorVersionFound": "Aucune version antérieure n'a été trouvée.",
  "overallVariance": "Variation générale",
  "topIncreases": "Augmentations maximales",
  "noIncreasesToHighlight": "Pas d'augmentation pour mettre en évidence.",
  "topDecreases": "Baisses maximales",
  "noDecreasesToHighlight": "Pas de diminutions pour mettre en évidence.",
  "votingManagement": "Gestion des votes",
  "openAndCloseVotingWindowsForBoardMembers": "Ouvrez et fermez les fenêtres de vote pour les membres du conseil.",
  "resendInvites": "Resend invite",
  "closeVoting": "Fermer Voting",
  "governanceRecord": "Compte rendu de la gouvernance",
  "unableToLoadMotionReviewData": "Incapable de charger des données d'examen des mouvements.",
  "votingOpened": "Vote ouvert",
  "boardVotingIsNowLive": "Le vote par le Conseil est maintenant en direct.",
  "unableToOpenVoting": "Incapable d ' ouvrir le vote",
  "inviteSent": "Invite envoyée",
  "inviteRefreshed": "Invite rafraîchie",
  "votingLinkAndOTPResent": "Le lien de vote et le ressentiment OTP.",
  "inviteTokenRefreshedForThisVoter": "Invitez le jeton rafraîchi pour cet électeur.",
  "inviteNotRequired": "Invite non requise",
  "thisMemberVotesInTheMembersPortal": "Ce membre vote dans le Portail des Membres.",
  "missingEmail": "Messagerie manquant",
  "noEmailIsAvailableForThisBoardMember": "Aucun courriel n'est disponible pour ce membre du conseil.",
  "unableToResendInvite": "Incapable de réenvoyer l'invitation",
  "votingClosed": "Vote fermé",
  "theResolutionHasBeenFinalized": "La résolution a été finalisée.",
  "unableToCloseVoting": "Impossible de clore le vote",
  "backToVoting": "Retour au vote",
  "motionNotFound": "La motion n'a pas été trouvée.",
  "motionCreated": "Motion créée",
  "motionOpened": "Motion ouverte",
  "voteRecorded": "Crédit enregistré",
  "motionClosed": "Motion fermée",
  "motionApproved": "Motion approuvée",
  "motionRejected": "Motion rejetée",
  "motionWithdrawn": "Motion retirée",
  "budgetLocked": "Budget verrouillé",
  "budgetUnlocked": "Budget débloqué",
  "budgetCreated": "Budget créé",
  "noGovernanceEventsRecordedYet": "Aucun événement de gouvernance n'a encore été enregistré.",
  "board": "Conseil",
  "vote": "Votez :",
  "votingWindow": "Fenêtre de vote",
  "unit": "Unité",
  "hours": "heures",
  "days": "jours",
  "weeks": "semaines",
  "months": "mois",
  "setHowLongBoardVotingRemainsOpen": "Définir combien de temps le vote par le conseil reste ouvert.",
  "boardMembersWithMembersPortalAccess": "Membres du Conseil ayant accès au Portail des membres",
  "theseMembersWillVoteInsideTheMembersPortalVotingTab": "Ces membres voteront dans l'onglet de vote du Portail des Membres.",
  "loadingRoster": "Chargement de la liste...",
  "unableToLoadRoster": "Incapable de charger la liste.",
  "noPortalEnabledBoardMembersFound": "Aucun membre du conseil n'a trouvé de portail.",
  "boardMembersWithoutMembersPortalAccess": "Membres du Conseil sans accès au Portail des membres",
  "theseMembersWillReceiveATemporaryVotingLinkAndOneTimeCodeViaEmail": "Ces membres recevront un lien de vote temporaire et un code à la fois par courriel.",
  "noEmailOnFile": "Pas d'email sur le fichier",
  "everyoneHasPortalAccess": "Tout le monde a accès au portail.",
  "resendVotingInvites": "Réendre le vote invite",
  "confirm": "Confirmer",
  "votingPanel": "Panel de vote",
  "pendingForOpenVotingOpenThisMotionToBeginBoardVoting": "En attendant le vote ouvert, ouvrez cette motion pour commencer à voter.",
  "castYourVoteYourSelectionIsRecordedInstantly": "Faites votre vote. Votre sélection est enregistrée instantanément.",
  "voteYes": "Votez Oui",
  "voteNo": "Voter non",
  "resolution": "Résolution",
  "approved": "Postes approuvés",
  "membersPortal": "Portail des Membres",
  "emailLinkOTP": "Lien par courriel + OTP",
  "voters": "Voteurs",
  "loadingVoters": "Chargement des électeurs...",
  "method": "Méthode",
  "lastSent": "Dernier envoi",
  "notVoted": "Non voté",
  "resendVotingLinkOTP": "Réendre le lien de vote + OTP",
  "noVotersFound": "Pas d'électeurs.",
  "unableToLoadMotions": "Incapable de charger des mouvements",
  "pleaseTryAgainInAFewMoments": "Veuillez réessayer en quelques instants.",
  "openForVoting": "Ouvert pour le vote",
  "closedResolution": "Résolution privée",
  "withdrawnMotion": "motion retirée",
  "viewResolution": "Voir la résolution",
  "reviewMotion": "Motion de révision",
  "votingAndResolutions": "Votes et résolutions",
  "reviewBudgetMotionsOpenVotingAndRecordBoardDecisions": "Examiner les motions budgétaires, les votes ouverts et les décisions du conseil d'administration.",
  "queuedForGMSecretaryRelease": "Filed for gm/secretary release",
  "activeBoardDecisions": "Décisions du conseil d'administration actives",
  "loadingOpenMotions": "Chargement des motions ouvertes...",
  "noMotionsAreCurrentlyOpenForVoting": "Aucune motion n ' est actuellement ouverte au vote.",
  "closedMotions": "Motions fermées",
  "finalizedResolutions": "Résolutions finales",
  "loadingClosedMotions": "Chargement des motions fermées...",
  "noClosedMotionsYet": "Pas encore de motions fermées.",
  "refreshMotions": "Réflexion des motions",
  "draft": "Brouillon",
  "open": "Ouvrir",
  "closed": "Fermé",
  "withdrawn": "Retiré",
  "rejected": "Rejetée",
  "viewAvatar": "Voir avatar pour {name}",
  "memberStatus": "Statut actif pour {name}",
  "votedChoice": "Voter {choice}",
  "closesRelative": "Fermeture {time}",
  "selectedWindow": "la fenêtre sélectionnée",
  "openedWindow": "Le vote s'est ouvert — se ferme dans {window} .",
  "motionCountOne": "Mouvements au total : {count}",
  "motionCountMany": "Mouvements au total : {count}",
  "yoy": "{percent} de l'an dernier",
  "other": "Autre",
  "uncategorized": "Non classé",
  "unavailable": "Données financières non disponibles. Veuillez réessayer plus tard.",
  "meetingLoadFailed": "Impossible de charger des réunions. Veuillez réessayer.",
  "emailSubject": "Votez maintenant : {title}",
  "emailHeading": "Le vote par le Conseil est ouvert",
  "emailMotion": "Motion :",
  "emailCloses": "Fermes:",
  "emailHelp": "Utilisez le lien ci-dessous pour lancer votre vote. On vous demandera le code unique.",
  "emailCode": "Code unique:",
  "emailDeadline": "la date limite de vote",
  "missing_email": "Messagerie manquant",
  "no_member_match": "Pas d'enregistrement de membre correspondant",
  "portal_access_disabled": "Accès au portail handicapés",
  "missing_auth0_id": "Compte portail non disponible",
  "loadingOpenVotes": "Chargement des votes ouverts...",
  "unableToLoadVotingMotions": "Incapable de charger des motions de vote.",
  "boardVoting": "Vote du Conseil",
  "openMotions": "motions ouvertes",
  "reviewCurrentMotionsAndCastYourVoteBeforeTheDeadline": "Révisez les motions actuelles et lancez votre vote avant la date limite.",
  "noOpenMotionsRightNow": "Pas de motions ouvertes en ce moment.",
  "votes": "votes ·",
  "notYetVoted": "Pas encore voté",
  "reviewAndVote": "Examiner et voter",
  "loadingMotion": "Chargement du mouvement...",
  "unableToLoadMotionDetails": "Impossible de charger les détails du mouvement.",
  "motionReview": "Examen de la motion",
  "opens": "Ouverture",
  "yourVoteNotRecordedYet": "Votre vote n'a pas été enregistré",
  "motionTotals": "Total des mouvements",
  "votesSoFar": "Votes jusqu ' ici",
  "governanceTimeline": "Calendrier de la gouvernance",
  "timelineUpdatesWillAppearHere": "Les mises à jour du calendrier apparaîtront ici.",
  "castYourVote": "Faites votre vote.",
  "unableToRecordVotePleaseTryAgain": "Incapable d'enregistrer un vote. Veuillez réessayer.",
  "boardVotingAccess": "Accès aux voix",
  "verifyYourVotingAccess": "Vérifier votre accès aux votes",
  "thisVotingLinkIsMissingItsAccessToken": "Ce lien de vote manque son jeton d'accès.",
  "enterYourOneTimeCode": "Entrez votre code unique",
  "useTheCodeFromYourEmailToUnlockTheBallot": "Utilisez le code de votre email pour déverrouiller le bulletin de vote.",
  "6DigitCode": "Code à 6 chiffres",
  "verifying": "Vérifiant...",
  "verify": "Vérifie",
  "unableToVerifyTheCodePleaseTryAgain": "Impossible de vérifier le code. Veuillez réessayer.",
  "motionDetails": "Détails du mouvement",
  "votesRecorded": "Votes enregistrés :",
  "motionSubmitted": "Motion présentée",
  "attendeeCountOne": "Participants : {count}",
  "attendeeCountMany": "Participants : {count}"
}
